import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { CreateIdeaInput, CreateIdeaOutput } from "types/web-app";

export const createIdea = async (
  accessToken: string,
  input: CreateIdeaInput,
) => {
  try {
    const response = await fetchWithAuth("/ideas/create", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<CreateIdeaOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
